import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from 'react-query';

import {
    ROUTES_ACCOUNT,
    ROUTES_REAL_STATE,
    QUERIES_REAL_STATE,
} from '@constants';
import { useRealState } from 'contexts/RealStateContext';
import { Table } from 'components/organisms';
import { Button, HelperOptions } from 'components/atoms';

import { onErrorMessage, onSuccessMessage } from 'helpers';
import { getRealStateInsuranceCompanyIndex, removeRealStateInsuranceCompany } from 'services';
import { sweetAlert } from 'utils';

import { InsuranceCompanyListWrap } from './styles';
import Layout from '../../Layout';

const InsuranceCompany = () => {
    const navigate = useNavigate();
    const title = 'Seguradoras';

    const queryClient = useQueryClient();

    const { getLinkWithSlug } = useRealState();

    function onHandleNavigate(param: string) {
        navigate(param);
    }

    function newRegister() {
        onHandleNavigate(
            getLinkWithSlug(ROUTES_REAL_STATE.INSURANCE_COMPANY.FORM.fullPath)
        );
    }

    const { data: dataList, isLoading: isLoadingList } = useQuery(
        QUERIES_REAL_STATE.INSURANCE_COMPANY.base,
        () => getRealStateInsuranceCompanyIndex(),
        { refetchOnMount: true }
    );

    const { mutate: removeRegister, isLoading: isLoadingRemove } = useMutation(
        ({ id }: { id: number }) => removeRealStateInsuranceCompany(Number(id)),
        {
            mutationKey: QUERIES_REAL_STATE.INSURANCE_COMPANY.base,
            onSuccess: (response) => {
                onSuccessMessage(
                    title,
                    response?.data?.message || 'Registro removido com sucesso!'
                );

                queryClient.invalidateQueries(QUERIES_REAL_STATE.INSURANCE_COMPANY.base);
            },
            onError: (err) => onErrorMessage(title, err),
        }
    );

    function editRegister(id: string | number) {
        onHandleNavigate(
            getLinkWithSlug(`${ROUTES_REAL_STATE.INSURANCE_COMPANY.FORM.fullPath}/${id}`)
        );
    }

    function removeRegisterRequest(id: number) {
        sweetAlert
            .fire({
                title: 'Você tem certeza?',
                text: 'Se você confirmar este registro será removido e está ação não poderá ser revertida!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#2ba2e3',
                cancelButtonColor: '#FF4D4D',
                confirmButtonText: 'Sim, remover registro!',
                cancelButtonText: 'Não, cliquei errado!',
            })
            .then((result) => {
                if (result.isConfirmed) {
                    removeRegister({ id });
                }
            });
    }

    return (
        <Layout
            titlePage="Painel Imobiliário"
            breadcrumbs={[
                {
                    label: 'Home',
                    href: getLinkWithSlug(ROUTES_ACCOUNT.SELECTED.fullPath),
                },
                {
                    label: title,
                    href: getLinkWithSlug(ROUTES_REAL_STATE.INSURANCE_COMPANY.fullPath),
                },
            ]}
            title={title}
            buttonTitle={
                <Button color="nonary" onClick={() => newRegister()}>
                    Novo Registro
                </Button>
            }
        >
            <InsuranceCompanyListWrap className="insurance-company-template">
                <Table
                    isLoading={isLoadingList || isLoadingRemove}
                    columns={[
                        {
                            dataField: 'nome',
                            text: 'Nome',
                            sort: true,
                            headerStyle: { width: '100%' }
                        },
                        {
                            dataField: 'numero',
                            text: 'Número',
                            sort: true,
                            headerStyle: { width: '100%' }
                        },

                        {
                            dataField: 'id',
                            text: 'Opções',
                            formatter: (fieldValue) =>
                                HelperOptions({
                                    editFunction: () => editRegister(fieldValue),
                                    removeFunction: () => removeRegisterRequest(fieldValue)
                                })
                        }
                    ]}
                    data={dataList}
                />
            </InsuranceCompanyListWrap>
        </Layout>
    );
};

export default InsuranceCompany;
